import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgNutritionCalculatorMealBuilderMobileGraphFooter',
})
export default class CmgNutritionCalculatorMealBuilderMobileGraphFooter extends Vue {
  windowSize = 0;
  graphFooterTop = 0;

  get currentNutrition() {
    return this.$store.state.mealBuilderV2.nutrition;
  }

  get getFullNutritionURL(): string | undefined {
    return this.$appStore.state.cms.fullNutritionURL;
  }

  get kebabIconUrl(): string {
    return this.$appStore.state.cms.images.icons.kebabMenu.default;
  }

  get footerIsSticky(): boolean {
    // Disabling the sticky nutrition footer for now
    // return (this.windowSize <= this.graphFooterTop) ? true : false;
    return false;
  }
 
  onScroll() {
    this.graphFooterTop = (this.$refs.graphFooter as HTMLElement).getBoundingClientRect().top;
  }

  onResize() {
    this.windowSize = window.innerHeight;
  }

  async mounted() {
    window.addEventListener('scroll', this.onScroll);
    window.addEventListener('resize', this.onResize);

    this.windowSize = window.innerHeight;
    this.graphFooterTop = this.windowSize;
  }
  
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  currentNutritionValue(key: string) {
    return Math.round(this.currentNutrition[key]);
  }

  onClickFullDetails() {
    this.$services.ui.setModalVisibility('mobileNutritionDetails', true);
  }
}
